import React from "react";

import SideBarTopLinks from "./SideBarTopLinks";
import HomeCalendar from "../Container/pages/Home/news-notification/HomeCalendar";

const Sidebar = ({ benchId, calendarId }) => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-3">
        <div className="about-rct-sec blue-box">
          <SideBarTopLinks benchId={7} />
          <HomeCalendar benchId={calendarId} />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
